<nav role="navigation" aria-label="Breadcrumbs">
  <ol class="slds-breadcrumb slds-list_horizontal slds-wrap">
    <li *ngFor="let breadcrumb of breadcrumbs$ | async" class="slds-breadcrumb__item">
      <a *ngIf="breadcrumb.isParent" routerLink="/home">{{ 'breadcrumbs.' + breadcrumb.breadcrumb | translate }}</a>
      <span *ngIf="!breadcrumb.isParent">{{ 'breadcrumbs.' + breadcrumb.breadcrumb | translate }}</span>
    </li>
  </ol>
</nav>
